/**
 * 講師リクエスト（希望日時）の型と定数 (SPEAKOUT-1853)
 *
 * 予約は「サーバーが用意した枠(inst_schedule.id)」を選ぶが、リクエストは枠が無いところへ
 * 希望を出す機能なので、対応するIDが無い。そのため日付・開始・終了を自分で持つ。
 */

/** 希望日時の1行ぶん */
export type LiveReserveRequestPref = {
  /** 'YYYY-MM-DD'（input type="date" の値と同じ形式） */
  date: string;
  /** 'HH:MM' */
  start: string;
  /** 'HH:MM' */
  end: string;
};

export type LiveReserveRequestPrefs = LiveReserveRequestPref[];

/** 希望は第1〜第3まで。★3つとも必須（サーバー app/inquiry/_live_inst_request.php も同じ） */
export const LIVE_RESERVE_REQUEST_PREF_COUNT = 3;

/** 未入力の希望日時（state の初期値・入力クリア用） */
export function emptyLiveReserveRequestPrefs(): LiveReserveRequestPrefs {
  return Array.from(
    { length: LIVE_RESERVE_REQUEST_PREF_COUNT },
    () => ({ date: '', start: '', end: '' })
  );
}

/** 3つとも入力済みか（送信ボタンの活性判定に使う） */
export function isFilledLiveReserveRequestPrefs(prefs: LiveReserveRequestPrefs): boolean {
  return (
    prefs.length === LIVE_RESERVE_REQUEST_PREF_COUNT &&
    prefs.every((row) => Boolean(row.date && row.start && row.end))
  );
}
